import React, { useState } from "react";
import Layout from "../../Layout";
import "./project_case.css";

import Daisy_Banner from "../../Images/Daisy_Banner.png";

export default function Pet() {
  const [active, setActive] = useState("discover");

  function showDiscover() {
    setActive("discover");
  }
  function showWireframes() {
    setActive("wireframes");
  }
  function showDev() {
    setActive("dev");
  }
  function showFinal() {
    setActive("final");
  }

  return (
    <Layout>
      <main className="cs-page">
        {/* 1) FULL WIDTH HERO IMAGE */}
        <section className="cs-hero">
          <img src={Daisy_Banner} alt="Placeholder project hero" />
        </section>

        {/* 2) TITLE / TAGLINE / META */}
        <section className="cs-block">
          <h1 className="cs-title">
            {" "}
            <u>Daisy Pet Sitting & Services</u>
          </h1>
          <p className="cs-tagline">
            Empowering a small pet-sitting business with simple, trustworthy,
            user-friendly design.
          </p>

          {/* VIEW THE WEBSITE */}
          <h2 className="cs-h2 cs-link-heading">
  <a
    href="https://daisypetsittingandservices.com/"
    target="_blank"
    rel="noopener noreferrer"
  >
    View the website here!
  </a>
</h2>


          <div className="cs-divider" />

          <div className="cs-meta">
            <div className="cs-meta-item">
              <h3 className="cs-meta-label">Timeline</h3>
              <p className="cs-meta-text">September 2025 – November 2025</p>
            </div>
            <div className="cs-meta-item">
              <h3 className="cs-meta-label">Programs Used</h3>
              <p className="cs-meta-text">
                WordPress, Figma, Procreate, Adobe Photoshop & Illustrator,
                HTML/CSS, Canva
              </p>
            </div>
          </div>
          <div className="cs-divider" />
        </section>

        {/* 3) ABOUT THE PROJECT */}
        <section className="cs-block">
          <h2 className="cs-h2">About the Project</h2>
          <p className="cs-tagline">
            Daisy Pet Sitting & Services began as a project to help a small
            business owner present her work in a clean, trustworthy, and
            welcoming way. From wireframing the layout to implementing custom
            CSS, each step of the site was designed to create clarity, trust,
            and an easy experience for pet owners booking pet services. Working
            closely with the client, I turned her ideas into a functional site
            that reflects her personality and professionalism, yet has user
            friendliness in mind. This project strengthened my skills in design,
            communication, and service-focused development.
          </p>
        </section>
        <div className="cs-divider" />

        {/* 4) MY ROLE + ACCOMPLISHMENTS */}
        <section className="cs-block">
          <h2 className="cs-h2">My Role & Accomplishments</h2>
          <p className="cs-tagline">
            In this project, I handled the full website build — from layout
            planning to front-end customization and functionality. I worked
            closely with my client to translate her vision into a clean,
            user-friendly small-business website, using WordPress, custom CSS,
            and original iconography using my own art. My role combined
            technical problem-solving with UX-focused design choices to create a
            working and functional website.
          </p>

          <div className="cs-card">
            <div class="cs-item">
              <span class="cs-item-title">Brand Iconography:</span>
              <span class="cs-item-text">
                Created custom iconography and consistent visual elements to
                match the client’s brand using Procreate.
              </span>
            </div>

            <div class="cs-item">
              <span class="cs-item-title">UX Wireframing:</span>
              <span class="cs-item-text">
                Designed wireframes in Figma to plan layouts, improve clarity,
                and guide development.
              </span>
            </div>

            <div class="cs-item">
              <span class="cs-item-title">WordPress Custom Styling:</span>
              <span class="cs-item-text">
                Built the site using WordPress with custom CSS overrides for
                more refined control.
              </span>
            </div>

            <div class="cs-item">
              <span class="cs-item-title">Responsive Front-End Design:</span>
              <span class="cs-item-text">
                Implemented mobile-responsive layouts for various screen sizes.
              </span>
            </div>

            <div class="cs-item">
              <span class="cs-item-title">AI Automation:</span>
              <span class="cs-item-text">
                Developed a Python script using the OpenAI API to automatically
                generate weekly financial summaries for the client.
              </span>
            </div>
          </div>
        </section>

        <div className="cs-divider" />

        {/* 6) MY PROCESS: MENU (left) + PANEL (right) */}
        <section className="cs-block">
          <h2 className="cs-h2">My Process</h2>

          <div className="cs-process">
            <div className="cs-menu">
              <button
                className={
                  "cs-menu-item" + (active === "discover" ? " is-active" : "")
                }
                onMouseEnter={showDiscover}
              >
                Discovery & Communication
              </button>

              <button
                className={
                  "cs-menu-item" + (active === "wireframes" ? " is-active" : "")
                }
                onMouseEnter={showWireframes}
              >
                Wireframes & Prototypes
              </button>

              <button
                className={
                  "cs-menu-item" + (active === "dev" ? " is-active" : "")
                }
                onMouseEnter={showDev}
              >
                Development
              </button>

              <button
                className={
                  "cs-menu-item" + (active === "final" ? " is-active" : "")
                }
                onMouseEnter={showFinal}
              >
                Final Touches
              </button>
            </div>

            <div className="cs-panel">
              {/* DISCOVERY */}
              <div
                className="cs-pane"
                style={{ display: active === "discover" ? "block" : "none" }}
              >
                <h3 className="cs-pane-title">
                  {" "}
                  <u>Discovery & Communication </u>
                </h3>
                <p className="cs-tagline">
                  We first connected through a veterans Facebook community,
                  where she was seeking someone who could help bring her
                  pet-sitting business to life online. She was a passionate
                  small business owner who loved animals and wanted a website
                  that finally reflected her services, personality, and love for
                  pet sitting. Even though my background at the time was mainly
                  in coding custom sites with React.js—and I was new to
                  WordPress—she trusted me with her vision. From the beginning,
                  my goal was to understand what mattered most to her, capture
                  her brand, and blend her ideas with strong UI/UX fundamentals
                  to ensure the final product wasn’t just aesthetic, but usable.
                  I listened carefully, offered feedback when something needed
                  refinement, and always communicated the “why” behind my design
                  decisions.
                </p>

                <p className="cs-tagline">
                  Throughout the project, we established a foundation that kept
                  us aligned and connected. We communicated through text,
                  regular Zoom calls, and weekly check-ins to review progress,
                  discuss updates, and make decisions together. Every change I
                  made was documented, recorded, and shared in a Google Drive
                  log so she could follow along at every step. This process
                  allowed us to collaborate openly, adjust quickly, establish
                  trust, and stay on the same page from the first sketch to the
                  final website launch.
                </p>
              </div>

              {/* WIREFRAMES */}
              <div
                className="cs-pane"
                style={{ display: active === "wireframes" ? "block" : "none" }}
              >
                <h3 className="cs-pane-title">
                  <u>Wireframes & Prototypes</u>
                </h3>
                <p className="cs-tagline">
                  To establish the structure of the site, I created multiple
                  draft layouts in Figma and presented them to the client so she
                  could choose the draft that best matched her brand and vision.
                  Each draft focused on clarity, hierarchy, and ease of
                  navigation—especially important for pet owners who needed
                  quick access to services, and booking. Once she selected her
                  preferred wireframe, I implemented the design directly into
                  WordPress, recreating the layout with custom styling and
                  responsive structure.
                </p>

                <p className="cs-tagline">
                  From there, we reviewed each page together, gathering her
                  thoughts on spacing, visuals, copy placement, and overall
                  flow. I refined the design based on her feedback, repeated the
                  review process, and finalized the layout once we were both
                  confident in the experience. A key priority was ensuring the
                  website worked smoothly on every device—from phones to tablets
                  to desktops—so each iteration included thorough responsiveness
                  testing. When everything was polished and functional, we
                  published the final version of the site.
                </p>

                <div className="cs-divider" />

                <p className="cs-tagline">
                  <b>View my wireframes here:</b>
                </p>

                <p className="cs-tagline">
                  <span>
                    <a
                      href="https://www.figma.com/design/wx1OggJlsfF4X2bPyO38cK/About-Us?t=mUYKjtfk0szan0OU-1"
                      target="_blank"
                    >
                      {" "}
                      About Us
                    </a>{" "}
                  </span>
                  <span>
                    <a
                      href="https://www.figma.com/design/Va5oYhIdkP8Qm5sTbt3RdQ/Services?t=mUYKjtfk0szan0OU-1"
                      target="_blank"
                    >
                      {" "}
                      Services
                    </a>
                  </span>
                  <span>
                    <a
                      href="https://www.figma.com/design/CxRTdzizeb5yKK5DJbzZz2/Testimonials?t=mUYKjtfk0szan0OU-1"
                      target="_blank"
                    >
                      {" "}
                      Testimonials
                    </a>
                  </span>
                  <span>
                    <a
                      href="https://www.figma.com/design/prw8gaU7Olft6zSKPAz2Hl/FAQ?node-id=0-1&t=JkBOBKOIkSw41k30-1"
                      target="_blank"
                    >
                      {" "}
                      FAQ
                    </a>
                  </span>
                  <span>
                    <a
                      href="https://www.figma.com/design/VxJ5qXqEec49SJZmImW1JC/Gallery?t=JkBOBKOIkSw41k30-1"
                      target="_blank"
                    >
                      {" "}
                      Gallery
                    </a>
                  </span>
                </p>
              </div>

              {/* DEVELOPMENT */}
              <div
                className="cs-pane"
                style={{ display: active === "dev" ? "block" : "none" }}
              >
                <h3 className="cs-pane-title">
                  <u>Development</u>
                </h3>
                <p className="cs-tagline">
                  During development, my focus was on creating a seamless,
                  intuitive experience that felt as polished as any modern
                  service platform while remaining personal and true to the
                  client’s brand. One of the core features I built was an
                  interactive service area map, allowing potential clients to
                  visually confirm coverage zones and explore nearby
                  availability. This required custom JavaScript logic, embedded
                  map APIs, and tailored CSS styling to ensure the interface
                  remained clean, accessible, and easy to navigate. Every
                  element was implemented with accessibility, aesthetics, and
                  readability, ensuring that even first-time visitors could
                  quickly understand the flow of the website.
                </p>

                <p className="cs-tagline">
                  To support business operations beyond the website itself, I
                  also integrated AI-powered automation to assist the client
                  with their weekly financial tracking. This involved developing
                  a Python script using the OpenAI API to analyze submitted form
                  data and generate clear summaries that the client could use
                  for budgeting, forecasting, and business insights. Through
                  automation, I helped streamline her workflow so she could
                  focus more on her services and less on administrative and
                  accounting tasks.
                </p>

                <p className="cs-tagline">
                  Throughout the build, I placed a major emphasis on
                  responsiveness and used CSS to ensure the site functioned
                  flawlessly on phones, tablets, laptops, and large desktop
                  screens alike. Each layout was tested and optimized to
                  maintain visual clarity, strong hierarchy, and consistent
                  usability. The result is a site that not only looks
                  professional but adapts gracefully to every device, giving her
                  clients a reliable and trustworthy experience no matter how
                  they choose to browse or book.
                </p>
              </div>

              {/* FINAL TOUCHES */}
              <div
                className="cs-pane"
                style={{ display: active === "final" ? "block" : "none" }}
              >
                <h3 className="cs-pane-title">
                  <u>Final Touches</u>
                </h3>
                <p className="cs-tagline">
                  In the final stretch of the project, the focus shifted toward
                  refining the experience so the site felt polished, and ready
                  for real clients. This meant tightening layout spacing across
                  all screen sizes, smoothing out visual inconsistencies, and
                  making sure every component behaved predictably—whether it was
                  a button hover state, a form submission, or a navigation
                  pattern. I revisited each page with fresh eyes, ensuring the
                  brand’s warm, trustworthy tone carried through the color
                  palette, iconography, and overall flow. I also optimized image
                  loading, cleaned up CSS, and fine-tuned responsiveness so the
                  site felt just as natural on a phone as it did on a desktop.
                </p>

                <p className="cs-tagline">
                  Once the interface felt cohesive, I worked on small but
                  important touches that improved the client’s workflow. I
                  validated forms, created helpful empty states, and added
                  confirmational cues so users knew their actions went through.
                  I finalized documentation, including a setup guide, an
                  overview of the WordPress structure, and notes on how the
                  client could update content confidently on her own. The
                  biggest takeaway from this project was seeing how thoughtful
                  design and clear communication can transform a simple idea
                  into a fully realized platform that supports a small business
                  owner’s daily operations—not just aesthetically, but
                  practically.
                </p>
              </div>
            </div>
          </div>
        </section>

        <div className="cs-divider" />

        {/* 7) Learning & Impact */}
        <section className="cs-block">
          <h2 className="cs-h2">Learning & Impact</h2>
          <p className="cs-tagline">
            Building the Daisy Pet Sitting & Services website pushed me in ways
            that made me a better developer. It strengthened my ability to
            design a website with a website builder, adapt to new tools quickly,
            communicate and justify my choices, and create solutions that are
            both beautiful and practical. This project gave me a newfound
            appreciation for small businesses.
          </p>

          <div className="cs-card">
            <div class="cs-item">
              <span class="cs-item-title">Brand Alignment:</span>
              <span class="cs-item-text">
                Learned how to translate a client’s personality and values into
                visual design by studying her brand and applying it across
                icons, colors, and layout.
              </span>
            </div>

            <div class="cs-item">
              <span class="cs-item-title">UX Wireframing:</span>
              <span class="cs-item-text">
                Gained experience iterating quickly through Figma drafts,
                applying feedback professionally, and making design decisions
                grounded in user clarity rather than personal bias.
              </span>
            </div>

            <div class="cs-item">
              <span class="cs-item-title">Cross-Functional Communication:</span>
              <span class="cs-item-text">
                Learned how to guide a client through technical decisions by
                explaining options clearly, offering rationale behind UX
                choices, and maintaining steady communication through calls,
                messages, and shared logs—ensuring the project stayed aligned
                and stress-free for both sides.
              </span>
            </div>

            <div class="cs-item">
              <span class="cs-item-title">Decision-Making:</span>
              <span class="cs-item-text">
                Gained experience leading the entire process from discovery to
                deployment, making confident design and development choices,
                managing timelines, and keeping the project moving even when
                navigating new tools like WordPress and my army training.
              </span>
            </div>
          </div>
        </section>
        <div className="cs-divider" />

        {/* 8) Testimonial */}
        <section className="cs-block">
          <h2 className="cs-h2">Testimonial</h2>
          <p className="cs-tagline">
            "Working with Sabrina was a great experience. She took the time to understand 
            my brand, explained every design and technical decision clearly, 
            and we had weekly check ins. She also made sure that when the website
            would be handed off to me, that it wouldn't overwhelm me should I make any changes
            myself. The final website feels welcoming, 
            professional, and easy for my clients to navigate on any device. 
            I feel prideful sharing my site, knowing it truly represents my 
            services."
          </p>

          
        </section>
        <div className="cs-divider" />
      </main>
    </Layout>
  );
}
